import { Component, Input } from '@angular/core';
import { IconName, IconNamesEnum } from 'ngx-bootstrap-icons';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-segmented-navigation-item',
  templateUrl: './segmented-navigation-item.component.html',
  styleUrls: ['./segmented-navigation-item.component.scss'],
})
export class SegmentedNavigationItemComponent {
  @Input() name: string;
  @Input() itemsCount?: number;
  @Input() isActive = false;
  @Input() icon: IconNamesEnum | IconName | undefined = undefined;
  @Input() onlyDesktop: boolean;
}
